export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const SET_SIDEBAR_ITEMS = 'SET_SIDEBAR_ITEMS';
export const SET_SELECTED_SIDEBAR_ITEM = 'SET_SELECTED_SIDEBAR_ITEM';

export const toggleSidebar = () => ({
    type: TOGGLE_SIDEBAR,
});

export const setSidebarItems = (topMenu, subMenu, isApplicationAdmin, isCompanyAdmin) => ({
    type: SET_SIDEBAR_ITEMS,
    payload: { 
        topMenu: topMenu, subMenu: subMenu, 
        isApplicationAdmin: isApplicationAdmin, 
        isCompanyAdmin: isCompanyAdmin
    }
})

export const setSelectedSidebarItem = (selectedSidebarItem) => ({
    type: SET_SELECTED_SIDEBAR_ITEM,
    payload: selectedSidebarItem,
})
